//
// Copyright (c) 2021 Astute Global, Inc.
//

// @ts-ignore
import i18next from "i18n/i18n";
import { ButtonView, clickOutsideHandler, ContextualBalloon, Plugin } from "ckeditor5";

import responseCategoryIcon from "img/svg/add_category.svg";
import ResponseCategoryView from "./ui/responseCategoryView";

export default class ResponseCategoryUi extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [ContextualBalloon];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "ResponseCategoryUi";
  }

  init() {
    this._addToolbarButton();
    this.balloon = this.editor.plugins.get(ContextualBalloon);
  }

  get _isResponseCategoryViewInPanel() {
    return this.balloon.hasView(this.responseCategoryView);
  }

  _addResponseCategoryView() {
    this.responseCategoryView = this._createResponseCategoryView();
    const view = this.editor.editing.view;
    const viewDocument = view.document;
    this.responseCategoryView.disableCssTransitions();
    this.balloon.add({
      view: this.responseCategoryView,
      position: {
        target: () => {
          return view.domConverter.viewRangeToDom(viewDocument.selection.getFirstRange());
        },
      },
    });
    if (this.balloon.visibleView == this.responseCategoryView) {
      this.responseCategoryView.focus();
    }
    this.responseCategoryView.enableCssTransitions();
  }

  _addToolbarButton() {
    const editor = this.editor;
    editor.ui.componentFactory.add("responseCategory", (locale) => {
      const command = editor.commands.get("responseCategory");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.category.buttonName"),
        icon: responseCategoryIcon,
        tooltip: true,
      });
      button.bind("isEnabled").to(command);
      this.listenTo(button, "execute", () => this._showUi());
      return button;
    });
  }

  _cancelUi() {
    this.editor.commands.get("responseCategory").refresh();
    this._closeResponseCategoryView();
  }

  _closeResponseCategoryView() {
    if (this._isResponseCategoryViewInPanel) {
      this.balloon.remove(this.responseCategoryView);
      this.responseCategoryView.destroy();
      this.editor.editing.view.focus();
    }
  }

  _createResponseCategoryView() {
    const editor = this.editor;
    const command = editor.commands.get("responseCategory");
    const responseCategoryView = new ResponseCategoryView(editor, command);
    responseCategoryView.set({
      responseId: editor.config.get("responseId"),
    });
    responseCategoryView.on("submit", () => {
      editor.execute("responseCategory", {
        insertType: responseCategoryView.insertType,
        categoryId: responseCategoryView.categoryId,
        categoryName: responseCategoryView.categoryName,
      });
      this._closeResponseCategoryView();
    });
    responseCategoryView.on("cancel", () => {
      this._cancelUi();
    });
    clickOutsideHandler({
      emitter: responseCategoryView,
      activator: () => this._isResponseCategoryViewInPanel,
      contextElements: [this.balloon.view.element],
      callback: () => this._cancelUi(),
    });
    return responseCategoryView;
  }

  _showUi() {
    this._addResponseCategoryView();
    this.balloon.showStack("main");
  }
}
